<div class="sliders">
    <app-offer-slider *ngIf="sellableOffers" [offers]="sellableOffers" [title]="'SALES'"></app-offer-slider>
    <app-offer-slider *ngIf="rentableOffers" [offers]="rentableOffers" [title]="'RENTS'"></app-offer-slider>
</div>
<div>
    <app-google-maps class="unselectable"></app-google-maps>
</div>
